module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya/access/nagoya_point1_1-bae671da7bdff7f5583b0b4d6f9578e7.jpg";